import type { Organization } from '@types';
import { hasSignedMsa } from '../../functions/src/common/msaSigning.ts';

export function hasMsaAccess(organization?: Organization | null, now = Date.now()): boolean {
    if (!organization)
        return false;
    if (organization.isTestOrganization === true)
        return true;
    if (organization.msaTrialMode === 'app' && organization.trialEndsAt) {
        if (new Date(organization.trialEndsAt).getTime() > now)
            return true;
        return hasSignedMsa(organization) && organization.hasMsaSubscription === true && organization.subscriptionStatus === 'active';
    }
    return organization.hasMsaSubscription === true && ['active', 'on_trial', 'trialing'].includes(organization.subscriptionStatus || '');
}
